import React from "react";

import ScrollView from "devextreme-react/scroll-view";

import { GroupMembership, UserDefinition, UsersTree } from "@app/components";
import { useReverseRoute, useWindowDimensions } from "@app/contexts";

import "./super.scss";

export const SuperAdminUsers = () => {
  const { routeInit } = useReverseRoute("swsadmin/users");
  const { drawerHeight } = useWindowDimensions();
  return (
    <div
      ref={routeInit}
      id={"usersPage"}
      style={{ "--drawerHeight": `${drawerHeight}px` } as React.CSSProperties}
    >
      <div id={"usersList"}>
        <UsersTree />
      </div>
      <div id={"usersContent"}>
        <ScrollView>
          <UserDefinition />
          <GroupMembership />
        </ScrollView>
      </div>
    </div>
  );
};
